<template lang="pug">
#confirmar-territorio
    p.m-0.pb-2 {{ $t('mensagens.laudos.confirmarSolicitacaoLaudoCarbono') }}:

    p.pt-2(v-for='territorio in selecionados')
        b {{ territorio.nome }}

    .botao(slot='footer')
        BaseButton.mr-10(type='defaut', size='small', @click='voltar')
            | {{ $t('mensagens.comuns.voltar') }}

        BaseButton(type='primary', size='small', @click='confirmar')
            | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import TerritorioService from '@/services/TerritorioService';
import LaudosService from '@/services/LaudosService';
import TipoLaudo from '@/constants/TipoLaudo';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ConfimarTerritorioCarbono',

    components: {
        BaseButton
    },

    props: {
        selecionados: {
            type: [],
            default() {
                return [];
            }
        }
    },

    emits: ['voltar'],

    data() {
        return {
            filtroSelecionarTerritorio: '',
            territoriosSelecionados: [],
            territoriosNaoSelecionados: []
        };
    },

    methods: {
        voltar() {
            this.$emit('voltar');
        },

        async confirmar() {
            const territorios = {
                territoriosIds: this.selecionados.map(
                    selecionado => selecionado.id
                )
            };

            await TerritorioService.solicitacaoLaudo(territorios)
                .then(({ data }) => {
                    this.selecionados = {};

                    for (let i = 0; i < data.length; i += 1) {
                        let id = data[i].id;
                        this.selecionados[id] = data[i];
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.laudos.ocorreuUmErroAoBuscarTerritorios')
                    });
                });

            const informacaoLaudos = [];
            for (const id in this.selecionados) {
                let nomeRepresentante =
                    this.selecionados[id]['representantes'][0] !== undefined
                        ? this.selecionados[id]['representantes'][0][
                              'nomeRazaoSocial'
                          ]
                        : null;
                let cpfCnpjRepresentante =
                    this.selecionados[id]['representantes'][0] !== undefined
                        ? this.selecionados[id]['representantes'][0]['cpfCnpj']
                        : null;

                let tipoDocumentoRepresentante =
                        cpfCnpjRepresentante !== null
                        ? cpfCnpjRepresentante.length < 11 ? 'RUC' : 'CPF_CNPJ'
                        : null;

                informacaoLaudos.push({
                    nomeRepresentante: nomeRepresentante,
                    cpfCnpjRepresentante: cpfCnpjRepresentante,
                    tipoDocumentoRepresentante: tipoDocumentoRepresentante,
                    territorioId: this.selecionados[id]['id'],
                    tipoLaudoId: TipoLaudo.CARBONO
                });
            }

            LaudosService.cadastrarLaudos({ informacaoLaudos })
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.laudos.solicitacaoRealizadaComSucesso')
                    });
                    this.voltar();
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.response.data.mensagem
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
#confirmar-territorio {
    .botao {
        display: flex;
        justify-content: space-between;
    }
}
</style>
